import {ECardInfoResponsePayload} from '../../../models/api';

export default {
  eCardNumber: '001949491',
  info: 'Номер 01949491 серия 22 Пересадочный на 30 минут Действует по 28.02.21 Остаток 84.00 р.',
  stateCard: 'Действующий билет',
  tariff: '22 (Пересадочный 30 мин. Макс. 14000.00 р. Действ. 12 месяцев)',
  balance: '84.00',
} as ECardInfoResponsePayload;
